import {
    REQUEST_USERS_CONTACTS,
    RECEIVE_USERS_CONTACTS,
    UPDATE_USERS_CONTACTS,
    ERROR_USERS_CONTACTS,
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"


export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_USERS_CONTACTS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_USERS_CONTACTS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case UPDATE_USERS_CONTACTS:
            const data = state.data
            let index = null
            if(data.results){
                if(action.updateType == "delete"){
                    index = data.results.findIndex(item => item.id == action.id)
                    data.results.splice(index, 1)
                }else{
                    index = data.results.findIndex(item => item.id == action.id)
                    if(index > -1){
                        data.results[index] = action.payload
                    }else{
                        data.results.unshift(action.payload)
                    }
                }
            }
            return {
                ...state,
                isFetching: false,
                data,
                errors: action.errors
            }
        case ERROR_USERS_CONTACTS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}